<template>
    <div class="information">
      <div class="info-top">
        <!-- <div class="mess-con">
          <div class="mess-text">
            <div class="top-mess">{{activeDetail.CentralAchievements}}</div>
            <div class="top-message">{{activeDetail.CentralAchievementsTxt}}</div>
          </div>
        </div> -->
        <!-- <img src="@/assets/my/head.jpg" alt="">
        <div class="top-mess">{{activeDetail.CentralAchievements}}</div>
        <div class="top-message">{{activeDetail.CentralAchievementsTxt}}</div> -->
      </div>
      <div class="detail">
        <div class="gs">
          <div class="header">
            {{ $i18n.locale=='zh' ? infos.title : infos.english_title}}
          </div>
          <div class="header-sub">
            <span>{{$i18n.locale=='zh' ? infos.news_date : formatDate(infos.news_date)}}</span>&nbsp;
          </div>
          <div class="content" style="margin-top: 50px;" v-html="$i18n.locale=='zh' ? infos.content : infos.english_content">
            
          </div>
         
        </div>
        <!-- <gs v-if="contentId == '1'"></gs> -->
        <!-- <jz v-if="contentId == '2'"></jz>
        <zg v-if="contentId == '3'"></zg> -->
      </div>
      
    </div>
  </template>
  <script>
  import gs from './gs.vue';
  import jz from './jz.vue';
  import zg from './zg.vue';
  import mock2 from "../../../public/json/中心成果-会议活动.json";
  export default {
    name: '',
    components: {
      gs,
      jz,
      zg
    },
    computed:{
      activeDetail(){
        return this.$t('activeDetail')
      }
    },
    data() {
      return {
        contentId: '',
        infos:{}
      }
    },
    created() {
     
    },
    mounted(){
      const id = this.$route.query.id;
      this.contentId = id;
      this.getData()
    },
    methods:{
      getData(){
        for(var i = 0 ; i < mock2.RECORDS.length ;i++){
         if( mock2.RECORDS[i].id == this.contentId){
          this.infos = mock2.RECORDS[i];
          console.log( mock2.RECORDS[i])
         }
        }
      },
      formatDate(inputDate) {
        const date = new Date(inputDate);
        if (isNaN(date)) {
          console.error('Invalid date format');
          return null;
        }
        const months = [
          'January', 'February', 'March', 'April', 'May', 'June', 
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
.gs {
  .header {
    min-height: 60px;
    // padding: 0 2vw;
    box-sizing: border-box;
    font-family: Inter;
    font-weight: 600;
    font-size: 36px;
    color: #333640;
    line-height: 60px;
    text-align: center;
  }
  .header-sub {
    height: 24px;
    font-family: PingFang SC, PingFang SC;
    font-size: 18px;
    color: #61656c;
    line-height: 24px;
    display: flex;
    justify-content: center;
    margin: 24px 0px;
    padding-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6E8EB;
  }
  .content{
    // padding: 0 2vw;
    box-sizing: border-box;
    font-family: PingFang SC, PingFang SC;
    font-size: 18px;
    color: #61656C;
    line-height: 36px;
    text-align: left;
    margin-top: 30px;
    span{
        font-weight: 600;
    }
    ::v-deep img {
      width: 100% !important;
    }
  }
  img{
    width: 100%;
    margin-top: 30px;
  }
}


  .information {
    width: 100%;
    .info-top {
      .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    }
  }
  .detail {
    max-width: 1200px;
    margin: 0 auto;
    padding: 50px 0 130px 0;
    box-sizing: border-box;
    // min-height: 1000px;
    .header {
      min-height: 60px;
      font-family: Inter;
      font-weight: 600;
      font-size: 36px;
      color: #333640;
      line-height: 60px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .time {
      max-width: 1200px;
      height: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #61656C;
      line-height: 24px;
      font-style: normal;
      text-transform: none;
      margin: 24px auto 50px;
      padding-bottom: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #E6E8EB;
      img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }
    .content {
      text-align: left;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #61656C;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      img {
        width: 100% !important;
      }
    }
  }
  @media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .en-text {
    font-size: 30px !important;
  }
  .header {
    font-size: 18px !important;
    padding: 0 20px !important;
  }
  .content {
    font-size: 16px !important;
    padding: 0 20px !important;
    img {
      width: 100% !important;
    }
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
}
  </style>